export default () => ({
  root: {
    boxShadow: ['none', '!important'],
  },
});
